$(document).ready(function () {
    if ($('[data-search=destinations]').length > 0) {
        BindDestinationAutocomplete();
    }

    let flightSearchBlocks = $('.flight-search--mylla');
    if (flightSearchBlocks) {
        flightSearchBlocks.each(function () {
            SetupMyllaFlightSearch(this);
        });
    }

    let destinations = [];

    $.ajax({
        url: '/api/myllaflights/destinations',
        type: 'GET',
        contentType: 'application/json; charset=utf-8',
        dataType: 'json',
        success: function (data) {
            if (data.length > 0) {
                destinations = data;
            }
        }
    });


    function SetupMyllaFlightSearch(block) {

        let searchButton = $(block).find('.js-mylla-search-flights');

        $(searchButton).on('click', function () {
            OnSearchBtnClick(block);
        });

        let form = block.querySelector('form');
        $(form).submit(function (event) {
            event.preventDefault();
            var form = $(this);
            if (form.valid()) {
                $.ajax({
                    url: form.attr('action'),
                    type: form.attr('method'),
                    data: form.serialize(),
                    success: function (result) {
                        let outcome = form.find('.flight-search--outcome');
                        outcome.get(0).className = "flight-search--outcome";
                        outcome.get(0).classList.add(result.class);
                        outcome.get(0).textContent = result.message;
                    }
                });
            }
        });
    }

    function BindDestinationAutocomplete() {
        $('[data-search=destinations]').autocomplete({
            minLength: 1,
            source: function (request, response) {
                $.ajax({
                    url: '/api/myllaflights/destinations',
                    type: 'GET',
                    contentType: 'application/json; charset=utf-8',
                    dataType: 'json',
                    success: function (data) {
                        if (data.length > 0) {
                            let matchingDestinations = data.filter(name => name != null && name.toLowerCase().includes(request.term.toLowerCase()))
                            if (matchingDestinations.length > 0) {
                                response($.map(matchingDestinations, function (item) {
                                    return {
                                        label: item,
                                        value: item
                                    };
                                }));
                            } else {
                                var emptyResult = [1];
                                response($.map(emptyResult, function () {
                                    return {
                                        label: 'Sorry, we can\'t find a destination with that name',
                                        value: '0'
                                    };
                                }));
                            }
                        } else {
                            var emptyResult = [1];
                            response($.map(emptyResult, function () {
                                return {
                                    label: 'Sorry, we can\'t find a destination with that name',
                                    value: '0'
                                };
                            }));
                        }
                    }
                });
            },
            open: function () {
                $(this).data('uiAutocomplete').menu.element.removeClass();
                $(this).data('uiAutocomplete').menu.element.addClass('results');
                $(this).data('uiAutocomplete').menu.element.removeAttr('style');
                $('.flight-search--field.flight-search--destination').append($(this).data('uiAutocomplete').menu.element);
            }
        }).data('ui-autocomplete')._renderItem = function (ul, item) {
            if (item.value == '0') {
                return $('<li class="ui-state-disabled">' + item.label + '</li>').appendTo(ul);
            } else {
                return $("<li>")
                    .append(item.label)
                    .appendTo(ul);
            }
        };
    }

    function OnSearchBtnClick(block) {
        let step2 = $(block).find('.flight-search__step2');
        let outcomeMessage = $(block).find('.flight-search--outcome');

        // Initial Validation
        let destinationInput = $(block).find('input[name="Destination"]');
        let invalidDestination = $(block).find('span.flight-search__destination-invalid');
        let destinationRequired = $(block).find('span.flight-search__destination-required');
        let destinationInvalid = !ValidateDestination(destinationInput, destinationRequired, invalidDestination);

        let dateInput = $(block).find('input[name="Date"]');
        let dateRequired = $(block).find('span.flight-search__date-required');
        let invalidDate = $(block).find('span.flight-search__date-invalid');
        let dateInvalid = !ValidateDate(dateInput, dateRequired, invalidDate);

        if (dateInvalid || destinationInvalid) {
            step2.hide();
            outcomeMessage.get(0).textContent = '';
            return;
        }

        // Retrieve flight options
        let dateArray = $(dateInput).val().split("/");
        let dateAsString = `${dateArray[2]}${dateArray[1]}${dateArray[0]}`;
        
        let flightDropdown = $(step2).find('select[name="Flight"]');
        $.ajax({
            url: `/api/myllaflights/departures?destination=${destinationInput.val()}&date=${dateAsString}`,
            type: 'GET',
            contentType: 'application/json; charset=utf-8',
            dataType: 'json',
            success: function (data) {
                flightDropdown.empty();
                outcomeMessage.get(0).className = 'flight-search--outcome';
                if (data.length > 0) {
                    data.forEach(flight => {
                        let option = document.createElement("option");
                        option.value = `${flight.scheduledDateTime} ${flight.destination} (${flight.airlineIATA}${flight.flightNumber})`;
                        option.textContent = `${flight.scheduledDateTime} ${flight.destination} (${flight.airlineIATA}${flight.flightNumber})`;
                        flightDropdown.append(option);
                    });
                    outcomeMessage.get(0).textContent = '';
                    // Set form hidden fields to use on form submission
                    let hdnDestination = $(step2).find('#hdnDestination');
                    let hdnDate = $(step2).find('#hdnDate');
                    hdnDestination.val(destinationInput.val());
                    hdnDate.val((dateInput).val());
                    step2.show();
                } else {
                    outcomeMessage.get(0).textContent = 'No flights found, please check your destination and date and try again';
                    outcomeMessage.get(0).classList.add('flight-search-error');
                    step2.hide();
                }
            }
        });
    }

    function ValidateDestination(destination, requiredMessage, invalidMessage) {
        let valid = true;
        if (!destination.val()) {
            requiredMessage.show();
            return !valid;
        } else {
            requiredMessage.hide();
        }

        if (destinations && !destinations.includes(destination.val())) {
            invalidMessage.show();
            return !valid;
        } else {
            invalidMessage.hide();
        }

        return valid;
    }

    function ValidateDate(date, requiredMessage, invalidMessage) {
        let valid = true;
        if (!date.val()) {
            requiredMessage.show();
            invalidMessage.hide();
            return !valid;
        } else {
            requiredMessage.hide();

            let todaysDate = new Date();
            let dateArray = $(date).val().split("/");
            let dateObject = new Date(dateArray[1] + "/" + dateArray[0] + "/" + dateArray[2]);
            if (dateObject < todaysDate) {
                invalidMessage.show();
                return !valid;
            } else {
                invalidMessage.hide();
            }

            return valid;
        }
    }
});